import React from 'react'
import Slider from "react-slick";
// // import { StaticImage } from 'gatsby-plugin-image';



class RewardsSection extends React.Component {

  render() {

    const settings = {
      dots: false,
      infinite: true,
      speed: 1500,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 1000,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ]
    };

    return (
      <section className="rewards pt-100 mb-lg-4">
        <div className="container">
          <div className="row">
                <h1 className="main-heading text-center mb-lg-4">Our Recognitions and <span className="bluecolor">Rewards</span></h1>
                <div className="outder">
                  <Slider {...settings}>
                    <a target='_blank' rel="noreferrer" href='https://www.goodfirms.co/company/coinsclone'>
                    <img
                        src="https://coinsclone.mo.cloudinary.net/images/aboutus/goodfirms.webp"
                        alt="Goodfirms"
                        width={175}
                      /></a>
                      <a target='_blank' rel="noreferrer" href='https://www.designrush.com/agency/profile/coinsclone-cryptocurrency-exchange-script'>
                    <img
                      src="https://coinsclone.mo.cloudinary.net/images/aboutus/designrushh.webp"
                      alt="Designrush"
                      width={175}
                    /></a>
                    <a target='_blank' rel="noreferrer" href='https://www.crunchbase.com/organization/coinsclone'>
                    <img
                      src="https://coinsclone.mo.cloudinary.net/images/crunchbase_logo.webp"
                      alt="Crunchbase"
                      width={175}
                    /></a>
                    <a target='_blank' rel="noreferrer" href='https://sourceforge.net/software/product/Coinsclone/'>
                    <img
                      src="https://coinsclone.mo.cloudinary.net/images/aboutus/source-forge.webp"
                      alt="Source-Forge"
                      width={175}
                    /></a>
                    <a target='_blank' rel="noreferrer" href='https://www.g2.com/products/coinsclone-white-label-crypto-exchange-software-development/'>
                    <img
                      src="https://coinsclone.mo.cloudinary.net/images/aboutus/g2.webp"
                      alt="G2"
                      width={175}
                    /></a>
                    <a target='_blank' rel="noreferrer" href='https://www.topdevelopers.co/profile/coinsclone'>
                    <img
                      src="https://coinsclone.mo.cloudinary.net/images/aboutus/top-developers.webp"
                      alt="Top Developers"
                      width={175}
                    /></a>
                    <a target='_blank' rel="noreferrer" href='https://www.mobileappdaily.com/company/coinsclone'>
                    <img
                      src="https://coinsclone.mo.cloudinary.net/images/aboutus/mobileappdaily.webp"
                      alt="Mobile App Daily"
                      width={175}
                    /></a>
                    <a target='_blank' rel="noreferrer" href='https://www.trustpilot.com/review/coinsclone.com'>
                    <img
                      src="https://coinsclone.mo.cloudinary.net/images/aboutus/trustpilot.webp"
                      alt="Trustpilot"
                      width={175}
                    /></a>
                    <a target='_blank' rel="noreferrer" href='https://yourstory.com/companies/coinsclone'>
                    <img
                      src="https://coinsclone.mo.cloudinary.net/images/aboutus/yours_story.webp"
                      alt="Yours Story"
                      width={175}
                    /></a>
                    <a target='_blank' rel="noreferrer" href='https://www.zoominfo.com/c/coinsclone/453208609'>
                    <img
                      src="https://coinsclone.mo.cloudinary.net/images/aboutus/zoominfo.webp"
                      alt="Zoominfo"
                      width={175}
                    /></a>
                  </Slider>
                </div>
          </div>
        </div>
      </section>
    )
  }
}

export default RewardsSection